function transposeMap(originalMap: any): { [key: number]: string } {
    return Object.entries(originalMap)
        .map(([key, val]) => ([val, key]))
        .reduce((obj, [k, v]) => ({...obj, [(k as any)]: v}), {})
}

export default transposeMap;